// Save/load UI (docs/07) — list saved songs; new / load / rename / delete.

import type { SongMeta } from "../state/persistence.ts";
import { createDialog, type Dialog } from "./dialog.ts";

export interface SongMenuHandlers {
  list(): SongMeta[];
  currentId(): string;
  onNew(): void;
  onLoad(id: string): void;
  onRename(id: string, title: string): void;
  onDelete(id: string): void;
}

export interface SongMenu {
  element: HTMLElement;
  open(): void;
}

export function createSongMenu(handlers: SongMenuHandlers): SongMenu {
  const dialog: Dialog = createDialog("Songs");

  const newBtn = document.createElement("button");
  newBtn.type = "button";
  newBtn.className = "btn";
  newBtn.textContent = "New song";
  newBtn.addEventListener("click", () => {
    handlers.onNew();
    render();
  });

  const list = document.createElement("div");
  list.className = "song-list";

  dialog.body.append(newBtn, list);

  function render(): void {
    list.replaceChildren();
    const songs = handlers.list();
    const currentId = handlers.currentId();
    if (songs.length === 0) {
      const empty = document.createElement("p");
      empty.className = "song-list__empty";
      empty.textContent = "No saved songs yet.";
      list.append(empty);
      return;
    }
    for (const song of songs) {
      const row = document.createElement("div");
      row.className = "song-row";
      if (song.id === currentId) row.classList.add("is-current");

      const name = document.createElement("input");
      name.type = "text";
      name.value = song.title;
      name.className = "song-row__name";
      name.addEventListener("change", () => handlers.onRename(song.id, name.value.trim() || song.title));

      const loadBtn = document.createElement("button");
      loadBtn.type = "button";
      loadBtn.className = "lane__btn";
      loadBtn.textContent = song.id === currentId ? "Current" : "Open";
      loadBtn.disabled = song.id === currentId;
      loadBtn.addEventListener("click", () => {
        handlers.onLoad(song.id);
        dialog.close();
      });

      const delBtn = document.createElement("button");
      delBtn.type = "button";
      delBtn.className = "lane__btn lane__btn--del";
      let armed = false;
      delBtn.textContent = "Delete";
      delBtn.addEventListener("click", () => {
        if (!armed) {
          armed = true;
          delBtn.textContent = "Sure?";
          window.setTimeout(() => {
            armed = false;
            delBtn.textContent = "Delete";
          }, 2000);
        } else {
          handlers.onDelete(song.id);
          render();
        }
      });

      row.append(name, loadBtn, delBtn);
      list.append(row);
    }
  }

  return {
    element: dialog.element,
    open() {
      render();
      dialog.open();
    },
  };
}
